import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-for-cep-developers"
    }}>{`UXP for CEP Developers`}</h1>
    <h2 {...{
      "id": "goodbye-cep"
    }}>{`Goodbye CEP`}</h2>
    <p>{`The Common Extensibility Platform has been the method of choice for plugin developers who needed anything beyond the simplest of user interfaces. While it's still going to be around in Photoshop for some time, it will at some point be deprecated and then, eventually, removed from Photoshop.`}</p>
    <p>{`CEP is being retired for several reasons:`}</p>
    <ul>
      <li parentName="ul">{`CEP uses a full version of Chromium as a web host. This is very resource intensive for the host application, even more so since `}<em parentName="li">{`each`}</em>{` CEP plugin runs in its `}<em parentName="li">{`own`}</em>{` instance of Chromium.`}</li>
      <li parentName="ul">{`CEP doesn't talk directly to the host application, but requires that host scripts be written in ExtendScript, and passed to the app via EvalScript calls. So there are two different JavaScript engines running. In practice, this means that a plugin's code is artifically split between ExtendScript and JavaScript, and passing anything more than simple parameters between the two layers is awkward and inefficient.`}</li>
      <li parentName="ul">{`CEP plugins cannot use native host controls, so CEP dialogs and panels don't match host ones without a lot of CSS fiddling.`}</li>
      <li parentName="ul">{`The ExtendScript side of CEP uses a very old JavaScript version that lacks many modern features. As such, a developer must juggle two different JavaScript environments.`}</li>
    </ul>
    <h2 {...{
      "id": "hello-uxp"
    }}>{`Hello UXP`}</h2>
    <p>{`UXP supports the HTML and CSS you'll need to make simple or, with the addition of the React JavaScript framework, complex panels as well as dialogs and headless (no UI) plugins.`}</p>
    <p>{`Because UXP communicates directly with the host application, the issues associated with the CEP/ExtendScript interface disappear. In general, plugin development is simpler with UXP.`}</p>
    <p>{`UXP comes with a plugin loader and debugger that makes managing plugin development much simpler than what's available in CEP.`}</p>
    <p>{`UXP plugins can use the `}<a parentName="p" {...{
        "href": "https://opensource.adobe.com/spectrum-css/"
      }}>{`Spectrum CSS`}</a>{` components, which can be used to provide theme-aware cross-platform user interfaces that look the same across CC applications.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      